import { NEW_GOAL_REPLACE_TOP_LEVEL_VALUE, NEW_GOAL_UPDATE, NEW_GOAL_RESET_UPDATE } from './newGoalReducer';

export const updateGoalProperty = (key, value) => ({
  type: NEW_GOAL_REPLACE_TOP_LEVEL_VALUE,
  payload: {
    key,
    value,
  },
});

export const updateGoal = (updatedGoalValues) => ({
  type: NEW_GOAL_UPDATE,
  payload: updatedGoalValues,
});

export const resetUpdateGoal = (updatedGoalValues) => ({
  type: NEW_GOAL_RESET_UPDATE,
  payload: updatedGoalValues,
});
